<div class="topbar">
	<div class="topbar-brand">
		<span class="header-trigger" (click)="isCollapsed = !isCollapsed">
			<span class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
		</span>
		<a routerLink="/home" class="topbar-logo">
			<img src="/assets/images/ca-logo@3x.png" alt="Communications Authority of Kenya">
		</a>
		<div class="header-page-title">
			<h3>{{pageTitle}}</h3>
			<span class="header-crumb" *ngIf="sectionTitle">{{sectionTitle}}</span>
		</div>
	</div>
	<div class="topbar-user">
		<div ngbDropdown>
			<div ngbDropdownToggle class="topbar-user-toggle" id="profileDropdown">
				<div class="topbar-user-text">
					<span class="name">{{username}}</span>
					<small>{{roleLabel}}</small>
				</div>
				<span class="avatar-initials">{{initials}}</span>
			</div>
			<div ngbDropdownMenu aria-labelledby="profileDropdown">
				<a class="dropdown-item" [routerLink]="['/agent','self']">View Profile</a>
				<button class="dropdown-item" (click)="changePassword()">Change Password</button>
				<div class="dropdown-divider"></div>
				<button class="dropdown-item" (click)="logout()">Logout</button>
			</div>
		</div>
	</div>
</div>

<nz-layout class="app-layout">
	<nz-sider class="menu-sidebar" nzCollapsible nzWidth="256px" [(nzCollapsed)]="isCollapsed"
		[nzTrigger]="null">
		<div class="rail-tenant" *ngIf="!isCollapsed">
			<span class="chip">MSVS &middot; Regulator</span>
		</div>
		<ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
			<a nz-menu-item nzMatchRouter routerLink="/home">
				<fa-icon [icon]="faHome" class="me-1"></fa-icon>
				<span *ngIf="!isCollapsed">Home</span>
			</a>
			<li nz-submenu nzTitle="Subscribers" nzIcon="solution"
				*hasPermission="['SubscriberMsisdnSearch', 'SubscriberDocumentSearch']">
				<ul>
					<a nz-menu-item nzMatchRouter routerLink="/subscriber/sim-search"
						*hasPermission="['SubscriberMsisdnSearch']">
						Sim Search
					</a>
					<a nz-menu-item nzMatchRouter routerLink="/subscriber/document-search"
						*hasPermission="['SubscriberDocumentSearch']">
						Document Search
					</a>
				</ul>
			</li>
			<li nz-submenu nzTitle="Agents" nzIcon="user"
				*hasPermission="['AgentProvisioning','AgentList', 'AgentAccountApproval']">
				<ul>
					<a nz-menu-item nzMatchRouter routerLink="/agent/list" *hasPermission="['AgentList']">
						Agent List
					</a>
					<a nz-menu-item nzMatchRouter routerLink="/agent/provision" *hasPermission="['AgentProvisioning']">
						Agent Provision
					</a>
					<a nz-menu-item nzMatchRouter routerLink="/agent/approval/next"
						*hasPermission="['AgentAccountApproval']">
						Agent Approval
					</a>
				</ul>
			</li>
			<li nz-submenu nzTitle="File Management" nzIcon="import"
				*hasPermission="['PartnerList', 'ImportUploadCsvFile']">
				<ul>
					<a nz-menu-item nzMatchRouter routerLink="/import/list">
						Manage Imports
					</a>
					<a nz-menu-item nzMatchRouter routerLink="/import/docs">
						Documentation
					</a>
				</ul>
			</li>
			<li nz-submenu nzTitle="Partners" nzIcon="import" *hasPermission="['PartnerList']">
				<ul>
					<a nz-menu-item nzMatchRouter routerLink="/partner/list">
						Partner List
					</a>
				</ul>
			</li>
			<li nz-submenu nzTitle="Operations" nzIcon="user"
				*hasPermission="['PartnerList','MaskingList','AppRoleList']">
				<ul>
					<a nz-menu-item nzMatchRouter routerLink="/masking" *hasPermission="['MaskingList']">
						Masking
					</a>
					<a nz-menu-item nzMatchRouter routerLink="/role/list" *hasPermission="['AppRoleList']">
						Roles
					</a>
					<a nz-menu-item nzMatchRouter routerLink="/permissions" *hasPermission="['PermissionView']">
						Permissions
					</a>
					<!-- Reports moved to its own top-level submenu -->
					<!-- <a nz-menu-item nzMatchRouter routerLink="/notification-template-sms/list" *hasPermission="['SmsTemplateList']">
						Sms Templates
					</a>
					<a nz-menu-item nzMatchRouter routerLink="/notification-template-email/list" *hasPermission="['EmailTemplateList']">
						Email Templates
					</a> -->
					<a nz-menu-item nzMatchRouter routerLink="/setting-list" *hasPermission="['PropertyList']">
						Settings
					</a>
				</ul>
			</li>
			<li nz-submenu nzTitle="Reports" nzIcon="bar-chart">
				<ul>
					<a nz-menu-item nzMatchRouter routerLink="/reports">
						All Reports
					</a>
					<a nz-menu-item nzMatchRouter href="/reporting_api/" target="_blank">
						<fa-icon [icon]="faScrewdriverWrench" class="me-1"></fa-icon>
						<span *ngIf="!isCollapsed">Report Builder</span>
					</a>
				</ul>
			</li>
			<a nz-menu-item nzMatchRouter href="/help.html" target="_blank">
				<fa-icon [icon]="faQuestionCircle" class="me-1"></fa-icon>
				<span *ngIf="!isCollapsed">Online Help</span>
			</a>
		</ul>
		<div class="rail-version" *ngIf="!isCollapsed">
			<b>MSVS Console</b>
			v{{appVersion}} &middot; Axon
		</div>
	</nz-sider>
	<nz-layout class="content-layout">
		<nz-content>
			<div class="inner-content">
				<router-outlet></router-outlet>
			</div>
		</nz-content>
	</nz-layout>
</nz-layout>

<div class="app-footer">
	&copy; {{currentYear}} Axon. All rights reserved.
</div>
